import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const Hero = () => {
    const { settings, loading } = useSettings();

    const heroData = loading ? {
        title: 'Uzman Far, Stop Tamiri ve Temizliği',
        subtitle: 'İçi kararan, güneşten solan ve üzeri çizilmiş otomobil, kamyonet, otobüs ve motorsiklet FAR & STOP\'larınızı yeni gibi yapıyoruz.',
        phone: '',
        image: 'https://images.unsplash.com/photo-1601129181405-734c0d510074?w=800&h=600&fit=crop'
    } : {
        title: settings.heroTitle || 'Uzman Far, Stop Tamiri ve Temizliği',
        subtitle: settings.heroSubtitle || 'İçi kararan, güneşten solan ve üzeri çizilmiş otomobil, kamyonet, otobüs ve motorsiklet FAR & STOP\'larınızı yeni gibi yapıyoruz.',
        phone: settings.phone || '',
        image: settings.heroImage || 'https://images.unsplash.com/photo-1601129181405-734c0d510074?w=800&h=600&fit=crop'
    };
    return (
        <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 md:py-32 overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                    backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
                    backgroundSize: '40px 40px'
                }}></div>
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    {/* Content */}
                    <div className="space-y-6">
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                            {heroData.title}
                        </h1>
                        <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
                            {heroData.subtitle}
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                            <a
                                href={`tel:${heroData.phone}`}
                                className="group flex items-center justify-center space-x-2 bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all hover:scale-105 shadow-lg text-lg font-semibold"
                            >
                                <Phone size={24} />
                                <span>Hemen Ara</span>
                            </a>
                            <Link
                                to="/hizmetler"
                                className="group flex items-center justify-center space-x-2 bg-white text-gray-900 px-8 py-4 rounded-lg hover:bg-gray-100 transition-all hover:scale-105 shadow-lg text-lg font-semibold"
                            >
                                <span>Hizmetlerimiz</span>
                                <ArrowRight size={24} className="group-hover:translate-x-1 transition-transform" />
                            </Link>
                        </div>
                    </div>

                    {/* Image */}
                    <div className="relative">
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                            <img
                                src={heroData.image}
                                alt="Far Tamiri"
                                className="w-full h-auto object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
                        </div>
                        {/* Floating Card */}
                        <div className="absolute -bottom-6 -left-6 bg-white text-gray-900 p-6 rounded-xl shadow-2xl">
                            <div className="text-3xl font-bold text-blue-600">15+</div>
                            <div className="text-sm font-semibold">Yıllık Deneyim</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
